import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../../modules/shared/common.styles'

export const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),

  emailBoxFrame: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: 10,
    [theme.media.mobile]: {
      flexDirection: 'column',
      maxWidth: 556,
      marginTop: 10,
      gap: '5px'
    },
    [theme.media.smallMobile]: {
      flexDirection: 'column',
      marginTop: 10,
      gap: '5px'
    }
  },

  emailInput: {
    color: '#fff',
    width: 375,
    height: 48,
    borderRadius: 9999,
    backdropFilter: `blur(30px)`,
    backgroundColor: `rgba(61, 61, 61, 0.6)`,
    '&::placeholder': {
      fontFamily: 'GTWalsheim',
      color: '#dddddd',
      opacity: 1
    },
    [theme.media.mobile]: {
      width: 345,
      alignSelf: 'center'
    },
    [theme.media.smallMobile]: {
      width: 345,
      alignSelf: 'center'
    }
  },

  buttonWrapper: {
    [theme.media.mobile]: {
      padding: '15px 0 20px 0',
      alignSelf: 'center'
    },
    [theme.media.smallMobile]: {
      padding: '15px 0',
      alignSelf: 'center'
    }
  },

  errorMessage: {
    color: '#e73339',
    [theme.media.mobile]: {
      marginTop: '1px',
      fontSize: '14px'
    },
    [theme.media.smallMobile]: {
      marginTop: '0px',
      fontSize: '12px'
    }
  },

  exclamation: {
    marginTop: '5px'
  },

  checkEmailButton: {
    margin: 0,
    lineHeight: 0,
    [theme.media.mobile]: {
      width: 345
    },
    [theme.media.smallMobile]: {
      width: 345
    }
  },

  tvodButton: {
    backgroundColor: theme.neonPink,
    '&:hover': {
      backgroundColor: theme.neonPinkLight
    },
    '&[disabled]:hover': {
      backgroundColor: theme.neonPink
    }
  }
}))
